import React, { useState, useCallback, useEffect } from 'react';
import { InlineSelect } from '@ui/molecules/inputs/inline/InlineSelect';
import { TagsList } from '@ui/molecules/TagsList';
import './SelectTagsStyles.scss';
export default function SelectTags({ options, selectedValues, name, label, placeholder, searchPlaceholder, excludeValueFrom }) {
    const [selected, setSelected] = useState(selectedValues);
    const [excludedValue, setExcludedValue] = useState(null);
    useEffect(() => {
        if (!excludeValueFrom)
            return undefined;
        const field = document.querySelector(excludeValueFrom);
        if (!field)
            return undefined;
        const read = () => setExcludedValue(field.value ? Number(field.value) : null);
        read();
        field.addEventListener('change', read);
        return () => field.removeEventListener('change', read);
    }, [excludeValueFrom]);
    const offered = options.filter((o) => o.value !== excludedValue);
    const selectedIds = selected.filter((id) => id !== excludedValue);
    const selectedOptions = offered.filter((o) => selectedIds.includes(o.value));
    const available = offered.filter((o) => !selectedIds.includes(o.value));
    const handleAdd = (value) => setSelected((prev) => [...prev, value]);
    const handleRemove = useCallback((id) => setSelected((prev) => prev.filter((v) => v !== id)), []);
    const selectedTags = selectedOptions.map((o) => ({ id: o.value, label: o.label }));
    const renderValue = useCallback(() => selectedTags.length > 0 ? (React.createElement("span", { onClick: (e) => e.stopPropagation(), role: "presentation" },
        React.createElement(TagsList, { tags: selectedTags, onRemove: handleRemove }))) : (React.createElement("span", null, placeholder)), [selectedTags, handleRemove, placeholder]);
    return (React.createElement("div", { className: "selectTagsContainer" },
        React.createElement("input", { type: "hidden", name: name, value: "" }),
        selectedIds.map((id) => (React.createElement("input", { key: id, type: "hidden", name: name, value: id }))),
        React.createElement(InlineSelect, { className: "inlineSelectContainer", label: label, options: available, value: 0, onChange: handleAdd, showSearch: true, searchPlaceholder: searchPlaceholder, valueRenderer: renderValue })));
}
